export function isTesting () {
  return process.env.VUE_APP_ENV === 'testing'
}

export function isZavaEmail (email) {
  return email.match(/^e2e\+.*@(dred|zavamed).com$/gi)
}

export function isZavaBrand () {
  return process.env.VUE_APP_BRAND === 'zava'
}

export function isSuperdrugBrand () {
  return process.env.VUE_APP_BRAND === 'superdrug'
}

export function isAsdaBrand () {
  return process.env.VUE_APP_BRAND === 'asda'
}

export function thirdPartyBrand () {
  let thirdPartyBrand = false
  if (isSuperdrugBrand()) {
    thirdPartyBrand = 'sd'
  }

  return thirdPartyBrand
}
